<template>
  <div class="content-box">
    <div class="row">
      <div class="col-lg-12">
        <div class="element-wrapper" v-if="contenedor.id != null">
          <div class="element-box">
            <div class="padded-lg">
              <!--START - Projects list-->
              <div class="projects-list">
                <div class="">
                  <div class="project-head">
                    <div class="project-title mb-4">
                      <h5>Contenedor</h5>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="text-center">
                          <h6>Envía:</h6>
                          <UsuarioEnTablaComponent v-if="contenedor.usuario != null" :current="contenedor.usuario" />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="text-center">
                          <h6>Piloto:</h6>
                          <span v-if="contenedor.piloto">{{
                              contenedor.piloto
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="text-center">
                      {{ contenedor.barra }}
                      <br />
                      Matricula: {{ contenedor.matricula }}
                      <br />
                      <br />
                      <div class="badge badge-info">
                        {{ contenedor.estado_str }}
                      </div>
                    </div>
                    <div class="row align-items-center mt-3">
                      <table class="table table-clean">
                        <tbody>
                          <tr>
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Tarimas </span>
                            </td>
                            <td class="text-right">
                              <div class="value text-success">
                                {{ contenedor.detalle.length }}
                              </div>
                              <span class="sub-value text-danger" v-if="
                                contenedor.tarimas_pendientes_recepcionar > 0
                              ">
                                Pendientes de recepcionar
                                {{ contenedor.tarimas_pendientes_recepcionar }}
                              </span>
                            </td>
                          </tr>

                          <tr v-if="contenedor.fecha_retorno">
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Retorno </span>
                            </td>
                            <td class="text-right">
                              <div class="value" v-if="contenedor.fecha_retorno != null">
                                <timeago locale="es" :title="contenedor.fecha_retorno" :auto-update="60"
                                  :datetime="contenedor.fecha_retorno"></timeago>
                                <div class="sub-value">
                                  <span class="sub-value">
                                    {{ formatDatetime(contenedor.fecha_retorno) }}
                                  </span>
                                  <span class="fas fa-check text-success"></span>
                                </div>
                              </div>
                              <div class="value" v-else="contenedor.fecha_retorno == null">
                                <span class="fas fa-clock text-warning"></span>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="contenedor.fecha_llegada">
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Llegada </span>
                            </td>
                            <td class="text-right">
                              <div class="value" v-if="contenedor.fecha_llegada != null">
                                <timeago locale="es" :title="contenedor.fecha_llegada" :auto-update="60"
                                  :datetime="contenedor.fecha_llegada"></timeago>
                                <div class="sub-value">
                                  <span class="sub-value">
                                    {{ formatDatetime(contenedor.fecha_llegada) }}
                                  </span>
                                  <span class="fas fa-check text-success"></span>
                                </div>
                              </div>
                              <div class="value" v-else="contenedor.fecha_llegada == null">
                                <span class="fas fa-clock text-warning"></span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Salida </span>
                            </td>
                            <td class="text-right">
                              <div class="value" v-if="contenedor.fecha_salida != null">
                                <timeago locale="es" :title="contenedor.fecha_salida" :auto-update="60"
                                  :datetime="contenedor.fecha_salida"></timeago>
                                <div class="sub-value">
                                  <span class="sub-value">
                                    {{ formatDatetime(contenedor.fecha_salida) }}
                                  </span>
                                  <span class="fas fa-check text-success"></span>
                                </div>
                              </div>
                              <div class="value" v-else="contenedor.fecha_salida == null">
                                <span class="fas fa-clock text-warning"></span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Fin Carga </span>
                            </td>
                            <td class="text-right">
                              <div class="value" v-if="contenedor.fecha_fin_carga != null">
                                <timeago locale="es" :title="contenedor.fecha_fin_carga" :auto-update="60"
                                  :datetime="contenedor.fecha_fin_carga"></timeago>
                                <div class="sub-value">
                                  <span class="sub-value">
                                    {{ formatDatetime(contenedor.fecha_fin_carga) }}
                                  </span>
                                  <span class="fas fa-check text-success"></span>
                                </div>
                              </div>
                              <div class="value" v-else="contenedor.fecha_fin_carga == null">
                                <span class="fas fa-clock text-warning"></span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Inicio Carga </span>
                            </td>
                            <td class="text-right">
                              <div class="value" v-if="contenedor.fecha_inicio_carga != null">
                                <timeago locale="es" :title="contenedor.fecha_inicio_carga" :auto-update="60"
                                  :datetime="contenedor.fecha_inicio_carga"></timeago>
                                <div class="sub-value">
                                  <span class="sub-value">
                                    {{ formatDatetime(contenedor.fecha_inicio_carga) }}
                                  </span>
                                  <span class="fas fa-check text-success"></span>
                                </div>
                              </div>
                              <div class="value" v-else="contenedor.fecha_inicio_carga == null">
                                <span class="fas fa-clock text-warning"></span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="value"></div>
                              <span class="sub-value"> Creado </span>
                            </td>
                            <td class="text-right">
                              <div class="value" v-if="contenedor.fecha_creacion != null">
                                <timeago locale="es" :title="contenedor.fecha_creacion" :auto-update="60"
                                  :datetime="contenedor.fecha_creacion"></timeago>
                                <div class="sub-value">
                                  <span class="sub-value">
                                    {{ formatDatetime(contenedor.fecha_creacion) }}
                                  </span>
                                  <span class="fas fa-check text-success"></span>
                                </div>
                              </div>
                              <div class="value" v-else="contenedor.fecha_creacion == null">
                                <span class="fas fa-clock text-warning"></span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!--END - Projects list-->
            </div>
            <div class="col-12" v-if="error_msg">
              <small class="form-text text-danger">
                {{ error_msg }}
              </small>
            </div>
            <div class="form-buttons">
              <button class="btn btn-block btn-success" type="button" @click="recibirContenedor()" v-if="
                contenedor.fecha_salida != null &&
                contenedor.fecha_llegada == null
              ">
                Recepcionar Contenedor
              </button>
              <RecepcionarTarimaComponent v-if="
                contenedor.tarimas_pendientes_recepcionar > 0 &&
                contenedor.fecha_llegada != null
              " :contenedor_id="contenedor.id" @refresh="refresh" />
              <router-link class="btn btn-md btn-block btn-success" v-if="
                contenedor.tarimas_pendientes_recepcionar == 0 &&
                contenedor.fecha_retorno
              " :to="{ name: 'wms-recepcion-tarima-buscar', params: {} }">
                <i class="fas fa-dolly"></i>
                Recepcionar tarimas
              </router-link>
              <br />
              <span class="sub-value text-danger" style="font-size:13px" v-if="contenedor.fecha_salida == null">
                El contenedor aún no ha salido, solicitar a CEDIS el envío.
              </span>
              <button class="btn btn-md btn-block btn-info" type="button" @click="retornoContenedor" v-if="
                contenedor.tarimas_pendientes_recepcionar == 0 &&
                contenedor.fecha_retorno == null
              ">
                Finalizar Contenedor
              </button>
              <br v-if="
                contenedor.tarimas_pendientes_recepcionar == 0 &&
                contenedor.fecha_retorno == null
              " />
              <button class="btn btn-md btn-block btn-dark" type="button" @click="cancelar">
                Salir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script></script>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import RecepcionContenedorRecibirComponent from "@/components/wms/recepcioncontenedor/RecepcionContenedorRecibirComponent";
import RecepcionarTarimaComponent from "@/components/wms/recepcioncontenedor/RecepcionarTarimaComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuarioEnTablaComponent,
    RecepcionContenedorRecibirComponent,
    RecepcionarTarimaComponent,
  },
  data() {
    return {
      barra: "",
      error_msg: null,
      contenedor: {
        pk: null,
        fecha_llegada: null,
      },
    };
  },
  mounted() {
    this.refreshContenedor(this.$route.params.id);
  },
  methods: {
    formatDatetime(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    cancelar() {
      let self = this;
      self.$router.push({
        name: "wms-recepcion-contenedor-buscar",
        params: {},
      });
    },
    buscarContenedor(e) {
      e.preventDefault();
      let self = this;
      self.refreshContenedor(self.barra);
    },
    refresh() {
      let self = this;
      self.refreshContenedor(self.contenedor.barra);
    },
    refreshContenedor(barra) {
      let self = this;
      DynamicService.getById("wms", "contenedor", barra)
        .then((res) => {
          self.contenedor = res.data;
        })
        .catch((err) => {
          if (err.response.data.detail) {
            alert(err.response.data.detail);
            self.$router.push({
              name: "wms-recepcion-contenedor-buscar",
              params: {},
            });
          }
        });
    },
    recibirContenedor() {
      let self = this;
      DynamicService.postActionList(
        "wms",
        "contenedor",
        "recepcion_contenedor",
        {
          barra: self.contenedor.barra,
        }
      )
        .then((res) => {
          self.refreshContenedor(self.contenedor.id);
          Notifications.toast.success(
            "Recepcionar contenedor",
            "Realizado correctamente"
          );
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.detail) {
            self.error_msg = err.response.data.detail;
          }
        });
    },
    recibirTarimas() {
      let self = this;
      if (
        self.contenedor.fecha_llegada != null &&
        self.contenedor.fecha_retorno == null
      ) {
        self.$router.push({
          name: "wms-recepcion-contenedor-recepcion",
          params: { id: self.contenedor.id },
        });
      } else {
      }
    },
    finalizarRecepcion() {
      DynamicService.postActionList("wms", "contenedor", "retorno", {
        barra: self.contenedor.barra,
      })
        .then((res) => {
          self.refreshContenedor(self.contenedor.id);
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.detail) {
            self.error_msg = err.response.data.detail;
          }
        });
    },
    retornoContenedor() {
      let self = this;
      swal({
        title: "¡Importante!",
        text: "¿Quiere cargar una devolución al contenedor antes de retornarlo?",
        icon: "warning",
        buttons: ["No", "Si"],
        dangerMode: false,
      }).then((result) => {
        if (result) {
          self.$router.push({
            name: "wms-contenedor-editar",
            params: { id: self.contenedor.id },
          });
        } else {
          Notifications.alert.confirm(
            "Finalizar Contenedor",
            "¿esta seguro?",
            "",
            function () {
              DynamicService.postActionList("wms", "contenedor", "retorno", {
                barra: self.contenedor.barra,
              })
                .then((res) => {
                  self.refreshContenedor(self.contenedor.id);
                  Notifications.toast.success(
                    "Finalizar Contenedor",
                    "Realizado correctamente"
                  );
                })
                .catch((err) => {
                  console.log(err.response.data);
                  if (err.response.data.detail) {
                    self.error_msg = err.response.data.detail;
                  }
                });
            }
          );
        }
      });
    },
  },
};
</script>
